// extracted by mini-css-extract-plugin
module.exports = {"underground-icon":"_7a3fb80146--underground-icon--bCKpx","underground-icon--regions":"_7a3fb80146--underground-icon--regions--tWbN4"};